import {dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class MemberSearchData extends EntityData<MemberSearchData> {
    @identifier memberId: string;
    @field integratedLoyaltyId: string;
    @field memberLastName: string;
    @field memberFirstName: string;
    @field email: string;
    @field mobilePhone: string;
    @field chargeAccountName: string;
    @field membershipType: string;
    @field memberNo: string;
    @field memberCardNo: string;
    @field pointsBalance: number;
    @dateField expiryDate: Date;
    @field discontinued: boolean;

    get memberNoSummary(): string {
        return this.memberNo + " - " + this.memberFirstName + " " + this.memberLastName;
    }
}
